var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ListingWrapper", {
    staticClass: "activities-listing",
    attrs: {
      title: _vm.$t.__("common.labels.activities"),
      loading: _vm.loadingActivitiesPage,
      isTableLoading: _vm.isTableLoading
    },
    on: { "update-pagination": _vm.handleUpdatePagination },
    scopedSlots: _vm._u([
      {
        key: "listingTabs",
        fn: function() {
          return [
            !!_vm.listingTabs.length
              ? _c("TabsNav", {
                  attrs: { tabs: _vm.listingTabs, activeTab: _vm.activeTab },
                  on: {
                    "tab-clicked": function(tab) {
                      return _vm.handleSelectedTab(tab)
                    }
                  }
                })
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "settings",
        fn: function() {
          return [
            _c("ActivitiesListingSettingsHeader", {
              ref: "ActivitiesTable",
              attrs: { columns: _vm.columns, activeTab: _vm.activeTab },
              on: { updateColumns: _vm.handleUpdateColumns }
            })
          ]
        },
        proxy: true
      },
      {
        key: "listingActions",
        fn: function() {
          return [
            _c(
              "CompassMenu",
              {
                scopedSlots: _vm._u([
                  {
                    key: "dropdown",
                    fn: function() {
                      return [
                        _c("CompassMenuItem", {
                          attrs: { label: _vm.$t.__("common.labels.task") },
                          on: {
                            click: function($event) {
                              return _vm.handleCreateActivity("task")
                            }
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "prefixIcon",
                              fn: function() {
                                return [
                                  _c("CompassIcon", {
                                    attrs: {
                                      size: "large",
                                      icon: "obj-slsy-task"
                                    }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ])
                        })
                      ]
                    },
                    proxy: true
                  }
                ])
              },
              [
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.create_activity"),
                    dropdown: ""
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "table",
        fn: function() {
          return [
            _c("ActivitiesListingTable", {
              attrs: { isActivityPage: true, columns: _vm.columns }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }